import { BuildClass } from '../../../universal';
import { React, _ } from '../../lib';
import { CJSX, ConditionalObject, useStateSync } from './meta-types';
import { stubDiv, stubInput } from './stubs';
const CheckboxComponent = (props, ref) => {
    const container = React.useRef(stubDiv);
    const checkbox = React.useRef(stubInput);
    React.useImperativeHandle(ref, () => ({
        focus: () => {
            checkbox.current?.focus();
        },
        select: () => {
            checkbox.current?.select();
        },
        getElement: () => container.current,
    }));
    const [value, setValue] = React.useState(Boolean(props.value ?? false));
    const [focused, setFocused] = React.useState(false);
    useStateSync({
        stateVal: value,
        propVal: Boolean(props.value ?? false),
        setState: setValue,
        setProp: props.onUpdate,
    });
    const evFocus = React.useCallback((ev) => {
        ;
        (props.onFocus ?? _.noop)(ev);
        setFocused(true);
    }, [props.onFocus]);
    const evBlur = React.useCallback((ev) => {
        ;
        (props.onBlur ?? _.noop)(ev);
        setFocused(false);
    }, [props.onBlur]);
    const onChange = React.useCallback(() => {
        setValue(checkbox.current?.checked ?? false);
    }, [props.value]);
    const onClick = React.useCallback((ev) => {
        if (props.disabled || props.readOnly) {
            return undefined;
        }
        let newVal = !value;
        if (props.cbStyle === 'radio' && value) {
            newVal = value;
        }
        checkbox.current?.focus();
        setValue(newVal);
        (props.onClick ?? _.noop)(ev);
        ev.preventDefault();
        ev.stopPropagation();
        return false;
    }, [props.disabled, props.readOnly, props.onClick, props.cbStyle, value]);
    const clDivOuter = BuildClass({
        'ui5 ui5-checkbox': true,
        [props.className ?? '']: true,
        radio: props.cbStyle === 'radio',
        focused: focused,
        disabled: props.disabled ?? false,
    });
    const clDivInner = BuildClass({
        inner: true,
        selected: value,
        disabled: props.disabled ?? false,
        [BuildClass(props.classNameInner)]: true,
    });
    return (React.createElement("div", { ref: container, className: clDivOuter, title: props.title ?? undefined, onClick: onClick },
        React.createElement("div", { className: clDivInner },
            ConditionalObject(Boolean(props.lbl), React.createElement("span", { className: BuildClass(['lbl', props.classNameLabel]) }, props.lbl)),
            props.children),
        React.createElement(CJSX, { cond: !props.disableInputBox },
            React.createElement("input", { ref: checkbox, readOnly: true, type: props.cbStyle ?? 'checkbox', checked: value, onChange: onChange, onFocus: evFocus, onBlur: evBlur, ..._.omit(props, [
                    'lbl',
                    'value',
                    'onUpdate',
                    'inLabel',
                    'children',
                    'onFocus',
                    'onBlur',
                    'cbStyle',
                    'className',
                    'classNameLabel',
                    'classNameInner',
                ]) }))));
};
export const Checkbox = React.forwardRef(CheckboxComponent);
//# sourceMappingURL=checkbox.js.map